/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import Header from '../../components/header';
import { Route, Switch } from 'react-router-dom';
import RouteErrorBoundary from '../../components/error/RouteErrorBoundary';
import { AppLayout } from '../../layout/AppLayout';
import { RouteInterface, RoutesInterface } from '../../types/routes';
// import { AppHeader } from '../../components/header/AppHeader';
// import CCLogo from '../../images/Carbon_Calculator_logo.svg';
import CarbonCalculatorComparison from '../../apps/carbon-calculator/components/carbon-calculator-comparison';
import SimpleCarbonCalculator from '../../apps/carbon-calculator/components/simple-carbon-calculator';

export const emissionsCalculatorsRouteEntry: RouteInterface = {
  id: 'emissions_calculators_entry',
  label: 'Emissions Calculator',
  path: '/emissions-calculator',
  exact: false,
  component: EmissionsCalculatorsRoute
}

export const emissionsCalculatorsRoute: RouteInterface = {
  id: 'emissions_calculatorss',
  label: 'Emissions: Carbon Calculators',
  path: '/emissions-calculator',
  exact: false,
  icon: 'fa-calculator',
  component: CarbonCalculatorComparison,
  auth: true,
}

export const simpleCarbonCalculatorRoute: RouteInterface = {
  id: 'simple_emissions_calculators',
  label: 'Simple Emissions Calculator',
  path: '/emissions-calculator/simple',
  exact: false,
  icon: 'fa-calculator',
  component: SimpleCarbonCalculator,
  auth: true,
}

export const emissionsCalculatorsRoutes: RoutesInterface = {
  EMISSIONS_CALCULATORS: emissionsCalculatorsRoute,
  SIMPLE_CARBON_CALCULATOR: simpleCarbonCalculatorRoute
};

// const EmissionsCalculatorsAppRoute: AppRouteInterface = {
//   appName: 'Emissions Calculator',
//   appIcon: CCLogo,
//   hasSidebar: false,
// }

/**
 * Emissions Calculator App entry point
 */
export function EmissionsCalculatorsRoute() {

  const component = (props: any) => (
    <Header {...props} />
  );

  return (
    <RouteErrorBoundary>
      <AppLayout Header={<Route path={emissionsCalculatorsRoute.path} component={component} />}>
        <Switch>
          <Route {...simpleCarbonCalculatorRoute} />
          <Route {...emissionsCalculatorsRoute} />
        </Switch>
      </AppLayout>
    </RouteErrorBoundary>
  )
}
